'use strict';
var Promise = require('bluebird');
var loadMustache = require('./loadMustache');

function sendError (url) {
  return function (error) {
    window.Raven.captureMessage('Load Mustache file error', {
      extra: {
        error: error,
        url: url
      }
    });

    return Promise.reject(error);
  };
}

function saveTemplateToGlobal (name, template) {
  if (!window.mustacheTemplates) {
    window.mustacheTemplates = {};
  }
  window.mustacheTemplates[name] = template;
}

function generateTemplateObject (template, element) {
  var rel = element.getAttribute('rel');
  var name = element.getAttribute('name');

  saveTemplateToGlobal(name, template);

  var templateObject = {
    name: name,
    template: template,
    isMain: (rel === 'template')
  };

  if (!templateObject.isMain) {
    window.Mustache.compilePartial(name, template);
  }

  return templateObject;
}

function parseResponseArray (preparedTemplates) {
  return preparedTemplates.reduce(function (result, template) {
    result.templates[template.name] = template.template;
    result.main = template.isMain ? template.template : result.main;
    return result;
  }, { templates: {}, main: '' });
}

function loadElement (element) {
  var url = element.getAttribute('href');

  return loadMustache(url)
    .then(function (template) {
      return generateTemplateObject(template, element);
    })
    .catch(sendError(url));
}

function getMustacheFiles (DOMelementArray) {
  return Promise
    .all(DOMelementArray.map(loadElement))
    .then(parseResponseArray);
}

var mustachePromise = null;
var loadMustacheFiles = function () {
  if (mustachePromise) {
    return mustachePromise;
  }

  var DOMelementArray = $('.mustache-to-load').get();
  mustachePromise = getMustacheFiles(DOMelementArray);
  return mustachePromise;
};

loadMustacheFiles._getMustacheFiles = getMustacheFiles;
loadMustacheFiles._parseResponseArray = parseResponseArray;
loadMustacheFiles._generateTemplateObject = generateTemplateObject;

module.exports = loadMustacheFiles;
